export default centre => `Westfield ${centre.title} Shopping Centre`
